export const getTerminal = "getTerminal"
